import ReactDatePicker, { DatePickerProps as ReactDatePickerProps } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DatePicker.scss';

export const DatePicker = (props: ReactDatePickerProps) => {
  return (
    <ReactDatePicker
      wrapperClassName="custom-datepicker-wrapper"
      calendarClassName="custom-datepicker-calendar"
      popperClassName="custom-datepicker-popper"
      {...props}
    />
  );
};
